import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SerenaPage from "../pages/serena/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/serena",
    element: <SerenaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
